export class BaseWasmQuery {
    params;
    constructor(params) {
        this.params = params;
    }
}
